import { render, staticRenderFns } from "./ershoufang.vue?vue&type=template&id=797c6eec&scoped=true&"
import script from "./ershoufang.vue?vue&type=script&lang=js&"
export * from "./ershoufang.vue?vue&type=script&lang=js&"
import style0 from "./ershoufang.vue?vue&type=style&index=0&id=797c6eec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797c6eec",
  null
  
)

export default component.exports